export enum Stage {
  LOCAL = 'local',
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'prod',
}

export interface ApplicationConfig {
  apiUrl: string;
  apiKey: string;
  stage: Stage;
  sheetId: string;
  wpAdminUrl: string;
  adminUrl: string;
}
